import axios from './axios';

export const getCategory = () => axios.post('/api/Category/List', {
	  "limit": 1000,
	  "offset": 0,
	  "filter": {
	  },
	  "sorting": {
		"fieldName": "id",
		"direction": "asc"
	  }
	});

// export const getCategory = () => {
//   return new Promise((resolve) => {
//     resolve({
//       data: {
//         messages: [],
//         succeeded: true,
//         data: [
//           { id: 1, categoryId: 1, name: "Receptive Language", code: "RC", createdBy: null, createdAt: null, isDeleted: false },
//           { id: 2, categoryId: 2, name: "Expressive Language", code: "EC", createdBy: null, createdAt: null, isDeleted: false },
//           { id: 3, categoryId: 3, name: "Cognitive Skills", code: "CS", createdBy: null, createdAt: null, isDeleted: false },
//           { id: 4, categoryId: 4, name: "Gross Motor", code: "GM", createdBy: null, createdAt: null, isDeleted: false },
//           { id: 5, categoryId: 5, name: "Fine Motor", code: "FM", createdBy: null, createdAt: null, isDeleted: false },
//           { id: 6, categoryId: 6, name: "Activities of Daily Living", code: "ADL", createdBy: null, createdAt: null, isDeleted: false },
//           { id: 7, categoryId: 7, name: "Social Emotional", code: "SE", createdBy: null, createdAt: null, isDeleted: false },
//           { id: 8, categoryId: 8, name: "Play Behaviour", code: "PB", createdBy: null, createdAt: null, isDeleted: false }
//         ],
//         exception: null,
//         code: 0
//       }
//     });
//   });
// };
